import {createUwmRequestService} from '@uwm/host';

export default createUwmRequestService();
